import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import { SET_CURRENT_EDITOR, SET_STRUCTURE, CLEAR_STRUCTURE, CLEAR_STATE, STRUCTURE_INSERT_MODE_IMPORT } from './constants';

export const initialState = Map({
  currentEditor: undefined,
  structure: undefined,
  structureName: undefined,
  structureInsertMode: STRUCTURE_INSERT_MODE_IMPORT,
  changeStructureTriggerUid: undefined,
});

const spec = {
  [SET_CURRENT_EDITOR]: (state, action) => {
    const { currentEditor } = action.payload;
    return state.set('currentEditor', currentEditor);
  },
  [SET_STRUCTURE]: (state, action) => {
    const { structure, structureName, structureInsertMode, changeStructureTriggerUid } = action.payload;
    return state.merge({
      structure,
      structureName,
      changeStructureTriggerUid,
      structureInsertMode: structureInsertMode || STRUCTURE_INSERT_MODE_IMPORT,
    });
  },
  [CLEAR_STRUCTURE]: (state) => {
    return state.merge({ structure: undefined, structureName: undefined, changeStructureUid: undefined });
  },
  [CLEAR_STATE]: () => {
    return initialState;
  },
};

export default createReducerBySpec(spec, initialState);
